/**
 * FruitScene - Fruit slicing mini-game
 */

import { useState, useEffect } from 'react';

const FRUITS = ['🍎', '🍊', '🍋', '🍇', '🍓'];

export default function FruitScene({ level, isComplete, isListening }) {
  const [sliced, setSliced] = useState([]);

  useEffect(() => {
    setSliced([]);
  }, [level?.id]);

  useEffect(() => {
    if (isComplete) {
      const interval = setInterval(() => {
        setSliced(prev => {
          if (prev.length >= FRUITS.length) return prev;
          return [...prev, prev.length];
        });
      }, 200);
      return () => clearInterval(interval);
    }
  }, [isComplete]);

  return (
    <div style={styles.scene}>
      <div style={styles.bg} />
      <div style={styles.board}>
        {FRUITS.map((fruit, i) => (
          <div
            key={i}
            style={{
              ...styles.fruit,
              animationDelay: `${i * 0.2}s`,
              opacity: sliced.includes(i) ? 0.3 : 1,
              transform: sliced.includes(i) ? 'scale(0.8) rotate(20deg)' : 'scale(1)',
            }}
          >
            {fruit}
            {sliced.includes(i) && <div style={styles.sliceLine} />}
          </div>
        ))}
      </div>
      {isListening && <div style={styles.indicator}>🎤 Listening...</div>}
    </div>
  );
}

const styles = {
  scene: { position: 'absolute', inset: 0, overflow: 'hidden' },
  bg: { 
    position: 'absolute', 
    inset: 0, 
    background: 'linear-gradient(180deg, #fef3c7 0%, #fde68a 100%)' 
  },
  board: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: '300px',
  },
  fruit: {
    fontSize: '50px',
    animation: 'fruitBob 2s ease-in-out infinite',
    transition: 'all 0.3s ease',
    position: 'relative',
  },
  sliceLine: {
    position: 'absolute',
    top: '50%',
    left: '-10%',
    right: '-10%',
    height: '4px',
    background: '#ef4444',
    transform: 'rotate(-30deg)',
  },
  indicator: {
    position: 'absolute',
    bottom: '15%',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'rgba(0,0,0,0.6)',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '20px',
    fontSize: '14px',
  },
};
